module.exports = __webpack_public_path__ + "img/KSC00215.47232514.jpg";